/**
 * Shown while a lazily-loaded route chunk downloads.
 *
 * Previously the router used `<Suspense fallback={null}>`, which renders an
 * empty white page. On a fast desktop connection that is imperceptible, but on
 * mobile data a route chunk can take several seconds — indistinguishable from a
 * crashed site, and the likely source of some "won't load on mobile" reports.
 */
function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite" aria-busy="true">
      <span className="route-fallback__spinner" />
      <span className="route-fallback__label">Loading…</span>
    </div>
  )
}

export default RouteFallback
